<template>
    <div class="form-group pb-0">
        <label v-if="showLabel" for="type" class="version-label col-form-label text-right">{{ label }}</label>
        <div class="version-selection-dd">
            <select2
                class="form-control"
                :value="versionInfo.selected"
                @input="handleSelect2Update"
                :config="{ placeholder: '', width: '100%' }">

                <option v-for="item in versionInfo.availableSelections" :value="item.id" :key="item.id">{{item.name}}</option>

            </select2>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

var base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'version-selector',
    props: {
        currentSelection: String,
        showLabel: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            default: 'Version'
        }
    },
    data() {
        return {
            versionInfo: {
                selected: '0',
                availableSelections: [
                 {
                    id: 0,
                    name: "Master",
                    slug: ""
                 }
                ],
            },
        }
    },
    mounted() {
        axios.get(base_url + '/pimapi/languages', {})
        .then((response) => {
            response.data.payload.forEach((element, idx) => {
                this.$set(this.versionInfo.availableSelections, idx+1, element);
            });
            this.$emit('versionSelectionChange', this.versionInfo.selected);
            this.$emit('availableSelections', this.versionInfo.availableSelections);
        })
        .catch((error) => {
            console.log('version load ERROR!');
        });
    },
    methods: {
        handleSelect2Update(update) {
            this.$emit('versionSelectionChange', update);
        },
    },
    computed: {},
};
</script>

<style>
.version-selection-dd {
    min-width: 300px;
}
.version-label{
    padding-bottom: 0;
}
</style>